<template>
	<v-container fluid>
		<SignalR path="/hub/mantenimiento" @change="onChangeSocket" />

		<DialogNotificacion ref="dialogNotificacion" :isMobile="isMobile" />

		<v-row justify="center">
			<v-col cols="12">
				<TitleHeader
					title="Iniciar Tarea de Mantenimiento"
					:loading="loading"
					:isMobile="isMobile"
					hideButton
				/>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col :cols="isMobile ? '12' : '6'">
				<ActividadTable
					:actividad="actividad"
					class="elevation-2"
				/>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col :cols="isMobile ? '12' : '6'">
				<ActividadButton
					block
					large
					:disabled="loading"
					:loading="loading"
					:actividad="actividad"
					:mecanicoEstaAsignado="mecanicoEstaAsignado"
					@click="onClickIniciar()"
				/>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col :cols="isMobile ? '12' : '6'">
				<v-btn
					color="primary"
					block
					:disabled="loading"
					@click="onClickCancel()"
					>Cancelar</v-btn
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from "axios";
import ActividadTable from "../shared/ActividadTable.vue";
import TitleHeader from "../shared/TitleHeader.vue";
import DialogNotificacion from "../shared/DialogNotificacion.vue";
import ActividadButton from '../shared/ActividadButton.vue';
import { mapActions, mapState } from 'vuex';

export default {
	components: { TitleHeader, ActividadTable, DialogNotificacion, ActividadButton },
	props: {
		actividad: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		...mapState(['tiposEstados']),
		mecanicoEstaAsignado() {
			return this.actividad.mecanicos?.some(
				(mecanico) => mecanico.idPersona == this.actividad.idPersona
			) || false;
		},
		isMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
	},
	methods: {
		...mapActions(['getParsedParams']),
		async onChangeSocket(event) {
			const parsedParams = await this.getParsedParams(event);

			const dynamicKey =
				this.actividad.tipo == 3
					? "idMantenimientoCalendarioInspeccion"
					: "idMantenimientoTarea";

			const tieneActividadAsignada =
				parsedParams[dynamicKey] == this.actividad[dynamicKey];

			if (parsedParams.estado == this.tiposEstados["asignar"]) {
				if (tieneActividadAsignada) this.onClickCancel();
			} else if (
				parsedParams.estado == this.tiposEstados["iniciar"] ||
				parsedParams.estado == this.tiposEstados["finalizar"] ||
				parsedParams.estado == this.tiposEstados["unirse"] ||
				parsedParams.estado == this.tiposEstados["pausar"] ||
				parsedParams.estado == this.tiposEstados["salirse"]
			) {
				if (this.actividad.idPersona != parsedParams.idPersona) {
					if (tieneActividadAsignada) this.onClickCancel();
				}
			}
		},
		onClickIniciar() {
			if (this.actividad.enCurso) {
				if (this.mecanicoEstaAsignado) this.$emit("click:iniciar");
				else this.unirseActividad();
			} else {
				this.iniciarActividad();
			}
		},
		unirseActividad() {
			this.loading = true;

			axios
				.post("/Mecanicos/MecanicoUnirse", {
					idMantenimientoTarea: this.actividad.idMantenimientoTarea,
					idMantenimientoCalendarioInspeccion:
						this.actividad.idMantenimientoCalendarioInspeccion,
				})
				.then(() => {
					this.loading = false;
					this.$emit("click:iniciar");
				})
				.catch((error) => {
					this.loading = false;
					if (error.response?.status == 409) {
						this.$refs.dialogNotificacion.showDialogNotificacion(
							"Error al unirse",
							"No se ha podido unir a la actividad porque tiene otra actividad asignada en curso",
							"mdi-close-circle",
							"error"
						);
					}
					console.log(error);
				});
		},
		iniciarActividad() {
			this.loading = true;

			axios({
				url:
					this.actividad.tipo == 3
						? "/Mecanicos/IniciarInspeccion"
						: "/Mecanicos/IniciarTareaMantenimiento",
				method: this.actividad.tipo == 3 ? "PUT" : "POST",
				data: {
					idMantenimientoTarea: this.actividad.idMantenimientoTarea,
					idMantenimientoCalendarioInspeccion:
						this.actividad.idMantenimientoCalendarioInspeccion,
				},
			})
				.then(() => {
					this.loading = false;
					this.$emit("click:iniciar");
				})
				.catch((error) => {
					this.loading = false;
					if (error.response?.status == 409) {
						this.$refs.dialogNotificacion.showDialogNotificacion(
							"Error al iniciar",
							"No se ha podido iniciar la actividad porque tiene otra actividad asignada en curso",
							"mdi-close-circle",
							"error"
						);
					}
					console.log(error);
				});
		},
		onClickCancel() {
			this.$emit("click:cancelar");
		},
	},
};
</script>

<style scoped>
.container-height {
	height: calc(100vh - 240px);
}
</style>